<template>

    <!-- 要保人/受益人姓名變更 -->
    <Layout :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: false, to: {} } }">

        <h2 class="pb-8 text-2xl font-bold">
            申請明細
        </h2>

        <div class="pb-6">
            <h3 class="pb-4 text-xl font-bold">
                新要保人姓名
            </h3>
            <p class="pb-4 text-sm">
                同時辦理以下保單號碼之要保人姓名變更
            </p>
            <CaseBox :caseBox="newApplicantName" />
        </div>

        <div class="pb-2">
            <h3 class="pb-4 text-xl font-bold">
                新被保險人姓名
            </h3>
            <p class="pb-4 text-sm">
                同時辦理以下保單號碼之被保險人姓名變更
            </p>
            <CaseBox :caseBox="newAssuredName" />
        </div>

        <div class="text-center">
            <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true; }">取消預約申請</button>
        </div>

    </Layout>
    <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？" type="confirm"
             :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />

</template>

<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
console.log(route.query.id);

// #region  新要保人姓名
const newApplicantName = ref(null);

// 串接...
newApplicantName.value = {
    boxList: [{
        title: '林中富',
        list: [
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' },
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' }
        ]
    }]
};
// #endregion

// #region 新被保險人姓名
const newAssuredName = ref(null);

// 串接...
newAssuredName.value = {
    boxList: [{
        title: '林中富',
        list: [
            { key: '1066216930-00', value: 'XWO 富邦人壽富利旺終身壽險' }
        ]
    }]
};
// #endregion

const infoBoxVisble = ref(false);
const okHandel = () => {

};

</script>

<style scoped>
</style>
